import styles from './styles.module.scss';
import cn from 'classnames';
import { InlineSvg } from 'components/svg';
import { ReactNode, useState } from 'react';

type CollapsiblePanelProps = {
  title: ReactNode;
  children: ReactNode;
  defaultExpanded?: boolean;
  className?: string;
  headerActions?: ReactNode;
  headerContent?: ReactNode;
};

export const CollapsiblePanel = ({
  title,
  children,
  defaultExpanded = true,
  className,
  headerActions,
  headerContent
}: CollapsiblePanelProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={cn(styles.collapsiblePanel, className)}>
      <div className={styles.header}>
        <div className={styles.headerLeft} onClick={toggleExpand} aria-expanded={isExpanded}>
          <span className={cn('badge', 'badge-light-secondary', styles.title)}>{title}</span>
          {headerContent}
        </div>
        <div className={styles.headerActions}>
          {headerActions}
          <div
            className={cn('cursor-pointer', styles.chevron, { [styles.expanded]: isExpanded })}
            onClick={toggleExpand}
            aria-expanded={isExpanded}
          >
            <InlineSvg path="/media/workshop-log/collapsible.svg" className="svg-icon-2" svgClassName="text-primary" />
          </div>
        </div>
      </div>

      {isExpanded && <div className={styles.content}>{children}</div>}
    </div>
  );
};
